import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Maison from "@/pages/Maison";
import Crisopea from "@/pages/Crisopea";
import Product from "@/pages/Product";
import Domino from "@/pages/Domino";
import DominoProduct from "@/pages/DominoProduct";
import Maroquinerie from "@/pages/Maroquinerie";
import MaroquinerieProduct from "@/pages/MaroquinerieProduct";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NewsletterConfirm from "@/pages/NewsletterConfirm";
import NotFound from "@/pages/NotFound";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Un seul arbre de pages, monté sur "/" (FR) et sur "/en" (EN).
const pages = (
  <>
    <Route index element={<Home />} />
    <Route path="la-maison" element={<Maison />} />
    <Route path="crisopea" element={<Crisopea />} />
    <Route path="crisopea/:slug" element={<Product />} />
    <Route path="domino" element={<Domino />} />
    <Route path="domino/:serie/:roman" element={<DominoProduct />} />
    <Route path="maroquinerie" element={<Maroquinerie />} />
    <Route path="maroquinerie/:slug" element={<MaroquinerieProduct />} />
    <Route path="contact" element={<Contact />} />
    <Route path="confirmation-newsletter" element={<NewsletterConfirm />} />
    <Route path="mentions-legales" element={<Legal page="mentions" />} />
    <Route path="cgv" element={<Legal page="cgv" />} />
    <Route path="confidentialite" element={<Legal page="confidentialite" />} />
    <Route path="retours" element={<Legal page="retours" />} />
    <Route path="*" element={<NotFound />} />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/">{pages}</Route>
          <Route path="/en">{pages}</Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
